import { Injectable } from '@angular/core';
import {environment} from "../../../environments/environment";
import {Headers, Http} from "@angular/http";

import {AbstractControl} from '@angular/forms';
export class PasswordValidation {

    static MatchPassword(AC: AbstractControl) {
       console.log("dasdasd")
       let password = AC.get('vPassword').value; //  to get value in input tag
       let confirmPassword = AC.get('vConfirmPassword').value; // to get value in input tag
        if(password != confirmPassword) {
            console.log('false');
            AC.get('vConfirmPassword').setErrors( {MatchPassword: true} )
        } else {
            console.log('true');
            return null
        }
    }
}

@Injectable()
export class AdminService {

    private headers = new Headers({ 'Content-Type': 'application/x-www-form-urlencoded' });
    constructor(
        private http: Http
    ) { }

    //Fetch single audio information
    getAdminInfo(iAdminId){
        const promise = new Promise((resolve, reject) => {
            const apiURL = environment.BASE_URL+'/admin/'+iAdminId;
            this.http.get(apiURL)
                .toPromise()
                .then(
                    res => { // Success
                        resolve(res.json());
                    }
                ).catch(
                err => {
                    console.log(err.json());
                    reject(err.json());
                }
            );
        });
        return promise;
    }

    createAdmin(adminValue){
        const promise = new Promise((resolve, reject) => {
            let body = "vTitle="+adminValue.vTitle+"&ltDesctiption="+adminValue.tDescription;
            const apiURL = environment.BASE_URL+'/admin';
            this.http.post(apiURL,body,{headers: this.headers})
                .toPromise()
                .then(
                    res => { // Success
                        //console.log(res.json());
                        resolve(res.json());
                    }
                ).catch(
                err => {
                    console.log(err.json());
                    reject(err.json());
                }
            );
        });
        return promise;
    }

    updateAdmin(adminValue){
        const promise = new Promise((resolve, reject) => {
            let body = "vEmailId="+adminValue.vEmailId+"&vPassword="+adminValue.vPassword+"&iAdminId="+adminValue.iAdminId;
            const apiURL = environment.BASE_URL+'/editadmin';
            this.http.post(apiURL,body,{headers: this.headers})
                .toPromise()
                .then(
                    res => { // Success
                        //console.log(res.json());
                        resolve(res.json());
                    }
                ).catch(
                err => {
                    console.log(err.json());
                    reject(err.json());
                }
            );
        });
        return promise;
    }

}



// WEBPACK FOOTER //
// /home/sotsys211/work/src/ecard_new/backend/src/app/admin/services/admin.service.ts